export default {
  processed: [],
  description: [],
  name: [],
  mediaType: [
    {
      rule: 'oneof',
      parameters: ['MediaType'],
    },
  ],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
  profile: [
    {
      rule: 'reference',
      parameters: [],
    },
  ],
  mediaRel: [],
  isPrivate: [],
  restrictions: [
    {
      rule: 'enumeration',
      parameters: [],
    },
  ],
  likes: [],
  mediaStatus: [
    {
      rule: 'oneof',
      parameters: ['MediaStatus'],
    },
  ],
  mediaInformation: [],
  mediaReactions: [],
  tag: [],
  thumbnails: [],
  published: [],
  released: [],
  transparentTitleUrl: [],
  rating: [
    {
      rule: 'oneof',
      parameters: ['Rating'],
    },
  ],
  transparentTitleLocation: [],
  mediaRelLocation: [],
  thumbnail: [],
  thumbnailLocation: [],
  mediaPreviewUrl: [],
  mediaPreviewLocation: [],
  mediaPreviewDuration: [],
  mediaDuration: [],
  hasProcessed: [],
  minimumAppropriateAge: [],
  thumbnailDefaultUrl: [],
}
